import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";

const fields = {
	'guid': 'String',
	'type': 'String',
	'time': 'String',
	'translations': 'String!',
	'active': 'String!',
};

export default gql(`
	mutation email_template( ${ HelperGraphql.createFields( fields ) } ) {
	    email_template( ${ HelperGraphql.createVariables( fields ) } ) {
	        guid
	    }
	}
`);

